import { AccumulatorCard } from "../components/AccumulatorCard";
import { SEO } from "../components/SEO";
import { DemoBadge, SectionHeading } from "../components/ui";
import { accumulators } from "../data/demo";

export function AccumulatorsPage() {
  return (
    <div className="page-shell py-10 sm:py-14">
      <SEO
        title="Today's football accumulators"
        description="Explore lower-odds, weekend, football and big-odds accumulator ideas with hypothetical payout calculations."
        path="/accumulators"
      />
      <SectionHeading
        headingLevel={1}
        eyebrow="Multi-match picks"
        title="Today’s accumulators"
        description="Pick the style that matches your matchday. Lower odds are not safe; every accumulator can lose."
      />
      <div className="grid gap-4 md:grid-cols-2">
        {accumulators.map((accumulator) => (
          <AccumulatorCard accumulator={accumulator} key={accumulator.id} />
        ))}
      </div>
      <div className="mt-5">
        <DemoBadge />
      </div>
    </div>
  );
}
